import SDK from "src/sdk";
import { logError } from "src/utils/logger";

(() => {
    // Add our OnlineShopper interface to the window object
    window.OnlineShopper = SDK;

    // Create a container div for React to render into
    if (!document.getElementById("di-os-container")) {
        const element = document.createElement("div");
        element.id = "di-os-container";
        document.body.appendChild(element);
    }

    // Look for loader script tag
    const scriptEl = document.getElementById("_di-onlineshopper-loader");

    if (!scriptEl) {
        // Should only happen on our test page due
        return;
    }

    // Get setup values off of loader script tag
    const accountSlug = scriptEl.getAttribute("data-account");
    const env = scriptEl.getAttribute("data-api-env") || scriptEl.getAttribute("data-env") || process.env.NODE_ENV!;
    const srpLink = scriptEl.getAttribute("data-srp-link") || "";

    if (!accountSlug) {
        // Log this so we know if there are people out there relying on non-standard startup methods
        logError("Online Shopper loader is missing required attribute");
        return;
    }

    window.OnlineShopper.bootstrap(accountSlug, env, srpLink);
})();
